import React, { useEffect } from "react";
import ListProCard from "./ListProCard";
import { WhiteBackground } from "../../../../components/WhiteBackground";
import * as Reorder from "../../../../components/dnd/Reorder";

export default function ListView(props) {
  const {
    pros,
    deleteUser,
    addToShortlist,
    removeFromShortlist,
    isExpertPage,
    isShortlistPage,
    setIsAnythingSelected,
    setSelectedIds,
    selectedIds,
    createAutoLoginUrl,
    isSharePath = false,
    sorting,
    onReorder,
  } = props;

  const handleSelectedPros = (proId, selected) => {
    setSelectedIds((prevSelected) =>
      selected
        ? [...new Set([...prevSelected, proId])]
        : prevSelected.filter((id) => id !== proId),
    );
  };

  useEffect(() => {
    setIsAnythingSelected(selectedIds.length > 0);
  }, [selectedIds, setIsAnythingSelected]);

  const renderProCards = () => {
    return pros.map((pro, index) => (
      <ListProCard
        key={pro.userid}
        pro={pro}
        index={index}
        addToShortlist={addToShortlist}
        removeFromShortlist={removeFromShortlist}
        deleteUser={deleteUser}
        isExpertPage={isExpertPage}
        isShortlistPage={isShortlistPage}
        onSelect={handleSelectedPros}
        selected={selectedIds.includes(pro.userid)}
        createAutoLoginUrl={createAutoLoginUrl}
        isSharePath={isSharePath}
        enableDrag={sorting}
      />
    ));
  };

  if (sorting) {
    return (
      <WhiteBackground>
        <Reorder.Root options={pros} onUpdateOrder={onReorder}>
          <div className="flex flex-col">
            {renderProCards()}
          </div>
        </Reorder.Root>
      </WhiteBackground>
    );
  }

  return (
    <WhiteBackground>
      <div className="flex flex-col">
        {renderProCards()}
      </div>
    </WhiteBackground>
  );
}
